// Keep navigation within the existing private JMH workspace.
export const FOUNDER_PAGES = [
  ["/founder/cfo", "Overview"],
  ["/founder/operations", "Manage finances"],
  ["/founder/treasury", "Cash forecast"],
  ["/founder/close", "Financial close"],
  ["/founder/planning", "Planning"],
  ["/founder/assets", "Assets"],
  ["/founder/procurement", "Purchasing"],
  ["/founder/contract-to-cash", "Revenue"],
  ["/founder/tax-compliance", "Tax"],
  ["/founder/governance", "Governance"],
  ["/founder/ownership", "Ownership & IP"],
  ["/founder/time", "Time ledger"],
  ["/founder/hours", "Weekly hours"],
  ["/steward-and-stone/inbox", "Inbox"],
  ["/secure-intake", "Documents"],
  ["/founder/profile", "Your profile"],
];

export function safeFounderReturn(value) {
  const destination = typeof value === "string" ? value.replace(/\/+$/, "") : "";
  return FOUNDER_PAGES.some(([path]) => path === destination) ? destination : "/founder/cfo";
}

export function resolveApiBase(configured = "") {
  const base = String(configured || "").trim().replace(/\/+$/, "");
  return `${base === "undefined" || base === "null" ? "" : base}/api`;
}
